import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { LoginCallbackComponent } from './components/login-callback/login-callback.component';
import { HomeComponent } from './pages/home/home.component';
import { authGuard } from './guards/auth.guard';
import { RegisterComponent } from './pages/register/register.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PoliciesComponent } from './pages/policies/policies.component';
import { CompleteAccountComponent } from './pages/complete-account/complete-account.component';
import { InfoComponent } from './pages/info/info.component';
import { accountCompletedGuard } from './guards/account-completed.guard';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { GreetingsComponent } from './pages/greetings/greetings.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { MoodComponent } from './pages/mood/mood.component';
import { FeltComponent } from './pages/felt/felt.component';
import { BodyReactionComponent } from './pages/body-reaction/body-reaction.component';
import { ReasonComponent } from './pages/reason/reason.component';
import { DidDoComponent } from './pages/did-do/did-do.component';
import { DidThinkComponent } from './pages/did-think/did-think.component';
import { ShareLogComponent } from './pages/share-log/share-log.component';
import { HistoricalComponent } from './pages/historical/historical.component';
import { LogViewerComponent } from './pages/log-viewer/log-viewer.component';
import { OtherThoughtComponent } from './pages/other-thought/other-thought.component';
import { mindlogRegistrationGuard } from './guards/mindlog-registration.guard';
import { DeeplinkRedirectComponent } from './components/deeplink-redirect/deeplink-redirect.component';
import { AboutComponent } from './pages/about/about.component';
import { PsychologistComponent } from './pages/psychologist/psychologist.component';
import { AssociateToPsychologistComponent } from './pages/associate-to-psychologist/associate-to-psychologist.component';
import { EmotionalRegulationComponent } from './pages/emotional-regulation/emotional-regulation.component';
import { ChooseAPlanComponent } from './pages/choose-a-plan/choose-a-plan.component';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { AddAppointmentComponent } from './pages/add-appointment/add-appointment.component';
import { ViewDayComponent } from './pages/view-day/view-day.component';
import { PatientListComponent } from './pages/patient-list/patient-list.component';
import { InvitePatientComponent } from './pages/invite-patient/invite-patient.component';
import { AcceptInviteComponent } from './pages/accept-invite/accept-invite.component';
import { InvitesComponent } from './pages/invites/invites.component';
import { premiumAccountGuard } from './guards/premium-account.guard';
import { PremiumFeatureComponent } from './pages/premium-feature/premium-feature.component';
import { AccountComponent } from './pages/account/account.component';
import { AppointmentsReportComponent } from './pages/appointments-report/appointments-report.component';
import { AppointmentsReportViewComponent } from './pages/appointments-report-view/appointments-report-view.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [authGuard]
  },
  {
    path: 'info/:type/:highlight/:info/:message/:button-label',
    component: InfoComponent
  },
  {
    path: 'complete-account',
    component: CompleteAccountComponent,
    canActivate: [authGuard]
  },
  {
    path: 'terms',
    component: TermsComponent
  },
  {
    path: 'policies',
    component: PoliciesComponent
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'login-callback',
    component: LoginCallbackComponent
  },
  {
    path: 'mood',
    component: MoodComponent,
    canActivate: [authGuard, accountCompletedGuard, mindlogRegistrationGuard],
  },
  {
    path: 'felt',
    component: FeltComponent,
    canActivate: [authGuard, accountCompletedGuard, mindlogRegistrationGuard],
  },
  {
    path: 'body-reaction',
    component: BodyReactionComponent,
    canActivate: [authGuard, accountCompletedGuard, mindlogRegistrationGuard],
  },
  {
    path: 'reason',
    component: ReasonComponent,
    canActivate: [authGuard, accountCompletedGuard, mindlogRegistrationGuard],
  },
  {
    path: 'did-do',
    component: DidDoComponent,
    canActivate: [authGuard, accountCompletedGuard, mindlogRegistrationGuard],
  },
  {
    path: 'did-think',
    component: DidThinkComponent,
    canActivate: [authGuard, accountCompletedGuard, mindlogRegistrationGuard],
  },
  {
    path: 'other-thought',
    component: OtherThoughtComponent,
    canActivate: [authGuard, accountCompletedGuard, mindlogRegistrationGuard],
  },
  {
    path: 'share-log',
    component: ShareLogComponent,
    canActivate: [authGuard, accountCompletedGuard],
  },
  {
    path: 'log-viewer',
    component: LogViewerComponent,
    canActivate: [authGuard, accountCompletedGuard],
  },
  {
    path: 'request-psychologist',
    component: PsychologistComponent,
    canActivate: [authGuard, accountCompletedGuard],
  },
  {
    path: 'associate-to-psychologist',
    component: AssociateToPsychologistComponent,
    canActivate: [authGuard, accountCompletedGuard],
  },
  {
    path: 'sos',
    component: EmotionalRegulationComponent,
    canActivate: [authGuard, accountCompletedGuard],
  },
  {
    path: 'choose-a-plan',
    component: ChooseAPlanComponent,
    canActivate: [authGuard, accountCompletedGuard],
  },
  {
    path: 'premium-feature',
    component: PremiumFeatureComponent,
    canActivate: [authGuard, accountCompletedGuard],
  },
  {
    path: 'calendar',
    component: CalendarComponent,
    canActivate: [authGuard, accountCompletedGuard, premiumAccountGuard],
  },
  {
    path: 'add-appointment',
    component: AddAppointmentComponent,
    canActivate: [authGuard, accountCompletedGuard],
  },
  {
    path: 'view-day',
    component: ViewDayComponent,
    canActivate: [authGuard, accountCompletedGuard],
  },
  {
    path: 'patient-list',
    component: PatientListComponent,
    canActivate: [authGuard, accountCompletedGuard],
  },
  {
    path: 'invite-patient',
    component: InvitePatientComponent,
    canActivate: [authGuard, accountCompletedGuard, premiumAccountGuard],
  },
  {
    path: 'invite-list',
    component: InvitesComponent,
    canActivate: [authGuard, accountCompletedGuard, premiumAccountGuard],
  },
  {
    path: 'invite/:token',
    component: AcceptInviteComponent,
    canActivate: [],
  },
  {
    path: 'account',
    component: AccountComponent,
    canActivate: [authGuard, accountCompletedGuard],
  },
  {
    path: 'appointments-report',
    component: AppointmentsReportComponent,
    canActivate: [authGuard, accountCompletedGuard, premiumAccountGuard],
  },
  {
    path: 'appointments-report-view',
    component: AppointmentsReportViewComponent,
    canActivate: [authGuard, accountCompletedGuard, premiumAccountGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [authGuard, accountCompletedGuard],
    children: [
      {
        path: 'historical',
        component: HistoricalComponent,
        outlet: 'home'
      },
      {
        path: 'greetings',
        component: GreetingsComponent,
        outlet: 'home'
      },
      {
        path: 'profile',
        component: ProfileComponent,
        outlet: 'home'
      },
      {
        path: '',
        redirectTo: '/home/(home:greetings)',
        pathMatch: 'full'
      }
    ]
  },  
  { 
    path: 'deeplink', 
    component: DeeplinkRedirectComponent 
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  { path: '**', redirectTo: '/home' }
];
